import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";

const locationMenuProps = {
  PaperProps: {
    style: {
      maxHeight: 208,
      width: 494,
    },
  },
};

const wallMenuProps = {
  PaperProps: {
    style: {
      maxHeight: 208,
      width: 376,
    },
  },
};

const CustomizedFormControl = styled(FormControl)`
  margin-top: 0px;
  margin-left: 0px;
`;

const CustomizedLocationSelect = styled(Select)`
  width: 508px;
  height: 64px;
  border: 1px solid rgba(0, 0, 0, 0.42);
  box-sizing: border-box;
  border-radius: 8px;
  background-color: white;
  margin-top: 10px;
  margin-right: 15px;
  scrollbar-width: auto;
`;

const CustomizedScannerWallSelect = styled(Select)`
  width: 390px;
  height: 64px;
  border: 1px solid rgba(0, 0, 0, 0.42);
  box-sizing: border-box;
  border-radius: 8px;
  background-color: white;
  margin-top: 10px;
  margin-right: 15px;
  scrollbar-width: auto;
`;

const CustomizedMenuItem = styled(MenuItem)`
  padding: 16px;
`;

export default function DropDownSelect(props) {
  const { t } = useTranslation("translation");

  const [siteID, setsiteID] = React.useState("");
  const [wallId, setWallId] = React.useState("");

  const handleSiteChange = (event) => {
    setsiteID(event.target.value);
    props.handleSite(event.target.value);
  };

  const handleWallChange = (event) => {
    setWallId(event.target.value);
    props.handleWall(event.target.value);
  };

  return props.dropDownOptions[0].hasOwnProperty("scannerWallId") ? (
    <div>
      <CustomizedFormControl>
        <CustomizedScannerWallSelect
          id="scannerWallIDDropdown"
          displayEmpty
          value={wallId}
          onChange={handleWallChange}
          input={<OutlinedInput />}
          MenuProps={wallMenuProps}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return <p>{t("Assign ID")}</p>;
            }
            return props.dropDownOptions[selected].name;
          }}
          inputProps={{ "aria-label": "Without label" }}
        >
          {props.dropDownOptions.map((contents, index) => (
            <CustomizedMenuItem key={index} value={index}>
              {contents.name}
            </CustomizedMenuItem>
          ))}
        </CustomizedScannerWallSelect>
      </CustomizedFormControl>
    </div>
  ) : (
    <div>
      <CustomizedFormControl>
        <CustomizedLocationSelect
          id="selectLocationDropdown"
          displayEmpty
          value={siteID}
          onChange={handleSiteChange}
          input={<OutlinedInput />}
          MenuProps={locationMenuProps}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return <p>{t("Select Location")}</p>;
            }
            return props.dropDownOptions[selected].siteName;
          }}
          inputProps={{ "aria-label": "Without label" }}
        >
          {props.dropDownOptions.map((contents, index) => (
            <CustomizedMenuItem key={index} value={index}>
              {contents.siteName}
            </CustomizedMenuItem>
          ))}
        </CustomizedLocationSelect>
      </CustomizedFormControl>
    </div>
  );
}
